import React, { useMemo, useRef } from 'react'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { useRequestHandler } from '@/hooks/useRequestHandler'

import { conclusionSentencesFormHandle } from '@/pages/configuration/components/ConclusionSentencesForm'

import { useAppSelector } from '@/redux/rootReducer'
import { selectAuthUser, selectAuthUserUpdateRequestState, updateMyProfile } from '@/redux/reducers/auth.reducer'

import { isSuperAdmin } from '@/utils/type-guards'

import FormEmails, { EmailsFormValues, FormEmailsProps } from '../components/FormEmails'

export function FormEmail(props: Pick<FormEmailsProps, 'open' | 'onClose'>) {
  const profileFormRef = useRef<conclusionSentencesFormHandle>(null)
  const { t } = useTranslation()
  const { enqueueSnackbar } = useSnackbar()
  const { dispatch, requestTracker: authUserUpdateRequestTracker } = useRequestHandler({
    onSuccess: () => {
      enqueueSnackbar(t('notification.authUser.update.success'), { variant: 'success' })
    },
    onError: () => enqueueSnackbar(t('notification.authUser.update.error'), { variant: 'error' }),
    requestTrackerSelector: selectAuthUserUpdateRequestState,
  })

  const authUser = useAppSelector(selectAuthUser)

  //wait for the branch auth/me to be merge to put the right code here
  const profileFormInitialValues = useMemo(
    () => ({
      emails: isSuperAdmin(authUser) && authUser?.emailStatistics ? authUser.emailStatistics : [],
    }),
    [authUser]
  )

  const handleModifyProfile = (values: EmailsFormValues) => {
    dispatch(updateMyProfile({ emailStatistics: values.emails }))
  }

  return (
    <FormEmails
      {...props}
      ref={profileFormRef}
      onSubmit={handleModifyProfile}
      initialValues={profileFormInitialValues}
      isSubmitting={authUserUpdateRequestTracker.loading}
    />
  )
}
